import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

import UserType from 'src/model/user-types'

const Badge = props => {
  const { classes } = props

  const premiumControl = () => {
    const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
    if (
      userControl == 'Basic' ||
      userControl == 'AppSumo (Tier 2)' ||
      userControl == 'AppSumo (Tier 1)' ||
      userControl == 'AppSumo (Tier 2A)' ||
      userControl == 'AppSumo (Tier 1A)'
    ) {
      return {
        text: 'Plus',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
  }
  const viewContents = premiumControl()

  return viewContents ? (
    <div
      className={classes.badge}
      style={{
        backgroundColor: viewContents.backgroundColor,
      }}
    >
      <Typography
        fontSize={'11px'}
        fontWeight={500}
        style={{ color: viewContents.textColor }}
      >
        {viewContents.text}
      </Typography>
    </div>
  ) : null
}

export default withStyles(styles)(Badge)
